import { JUMP_TARGET } from "@/constants/index";
import store from "@/store/index";

export function getParamFromUrl(key, url) {
  if (!url) url = location.href;
  key = key.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + key + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : results[1];
}

export function jumpOutLink(path, query = {}) {
  let areaId = store.state.areaId;
  let ticket = store.state.ticket;
  let queryStr = "userType=2&";
  if (areaId !== 1) {
    queryStr += `areaId=${areaId}&`;
  }
  if (ticket) {
    queryStr += `gxdjkey=${ticket}&`;
  }
  for (let key in query) {
    queryStr += `${key}=${query[key]}&`;
  }
  return JUMP_TARGET + '#' + path + "?" + queryStr + "applyPlatform=1";
}
